import type { ExerciseResource } from '../types';
import styles from '../App.module.css';
import { useLanguage } from '../i18n/context';

interface ExercisesProps {
  items: ExerciseResource[];
}

const SAFETY_NOTE_JA =
  '運動は医師・助産師に相談のうえ。痛み・出血・破水・めまい・胎動異常があれば中止して受診してください。';
const SAFETY_NOTE_EN =
  'Consult your doctor or midwife before exercising. Stop and seek medical attention if you experience pain, bleeding, water breaking, dizziness, or abnormal fetal movement.';
const SAFETY_NOTE_ZH =
  '运动前请咨询医生或助产士。如出现疼痛、出血、破水、头晕或胎动异常，请立即停止并就医。';

const SAFETY_NOTES: Record<string, string> = {
  ja: SAFETY_NOTE_JA,
  en: SAFETY_NOTE_EN,
  zh: SAFETY_NOTE_ZH,
};

const LEVEL_LABELS: Record<string, Record<string, string>> = {
  ja: { gentle: 'やさしい', moderate: 'ふつう' },
  en: { gentle: 'Gentle', moderate: 'Moderate' },
  zh: { gentle: '轻度', moderate: '中等' },
};

export function Exercises({ items }: ExercisesProps) {
  const { locale } = useLanguage();
  const safetyNote = SAFETY_NOTES[locale] ?? SAFETY_NOTE_JA;
  const levelLabels = LEVEL_LABELS[locale] ?? LEVEL_LABELS.ja;

  return (
    <div className={styles.exercisesWrap}>
      <div className={styles.exercisesSafety}>{safetyNote}</div>

      <div className={styles.exercisesGrid}>
        {items.map((ex) => (
          <a
            key={ex.id}
            href={ex.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.exerciseCard}
          >
            <div className={styles.exerciseTop}>
              <span className={styles.exerciseDuration}>
                {locale === 'ja'
                  ? `${ex.durationMin}分`
                  : locale === 'zh'
                    ? `${ex.durationMin} 分钟`
                    : `${ex.durationMin}\u2009min`}
              </span>
              {ex.level && (
                <span className={`${styles.exerciseLevel} ${styles[`exerciseLevel${ex.level === 'gentle' ? 'Gentle' : 'Moderate'}`] ?? ''}`}>
                  {levelLabels[ex.level]}
                </span>
              )}
            </div>

            <h4 className={styles.exerciseTitle}>{ex.title}</h4>
            <span className={styles.exerciseChannel}>{ex.channel}</span>

            {ex.note && (
              <p className={styles.exerciseNote}>{ex.note}</p>
            )}

            <span className={styles.exerciseLink}>
              {locale === 'ja' ? '動画を観る →' : locale === 'zh' ? '观看视频 →' : 'Watch video →'}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}
